import React, { useState, useRef, useEffect } from "react";
import MetaTags from "react-meta-tags";
import { Row, Col, CardBody, Card, Alert, Container, Input, Label, Form, FormFeedback } from "reactstrap";
import { Link, useHistory } from "react-router-dom";
import ApiClient from "../../FindagramAdmin/BaseUrl/ApiClient";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useSelector, useDispatch } from "react-redux";
import { apiError } from "../../store/actions";
import ParticlesAuth from "../AuthenticationInner/ParticlesAuth";
import bitelogo from "../../assets/images/bitelogo.png";

const ForgetPasswordPage = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const [loading, setLoading] = useState(false);
    const isMounted = useRef(true);

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            email: "",
        },
        validationSchema: Yup.object({
            email: Yup.string()
                .email("Invalid email format")
                .required("Please enter your email"),
        }),
        onSubmit: async (values) => {
            setLoading(true);
            try {
                const response = await ApiClient().post("/auth/admin/forgotPassword", {
  email: values.email,
});



                console.log("API Response:", response);

                const message = response?.data?.responseMessage?.[0] || "Password reset email sent successfully";
                toast.success(message);

                setTimeout(() => {
                    history.push("/reset-password");
                }, 2000);
            } catch (error) {
                console.log("API Error:", error?.response); 
               (error?.response?.data?.responseMessage || ["Try again pls"]).forEach(
            (msg) => {
              toast.error(msg);
            }
          );
            } finally {
                if (isMounted.current) {
                    setLoading(false);
                }
            }
        },
    });

    const { registrationError } = useSelector((state) => ({
        registrationError: state.Account.registrationError,
    }));

    useEffect(() => {
        dispatch(apiError(""));
        return () => {
            isMounted.current = false;
        };
    }, [dispatch]);

    return (
        <React.Fragment>
            <ParticlesAuth>
                <div className="auth-page-content">
                    <MetaTags>
                        <title>Forget Password | BiteSaver</title>
                    </MetaTags>
                    <Container>
                        <Row>
                            <Col lg={12}>
                                <div className="text-center text-white-50">
                                   
                                         <Link to="/" className="d-inline-block auth-logo">
                                                                                     <   img  src={bitelogo} alt="BiteSaver Logo" height="150" />
                                                                                    </Link>
                                  
                                </div>
                            </Col>
                        </Row>

                        <Row className="justify-content-center">
                            <Col md={8} lg={6} xl={5}>
                                <Card className="mt-4">
                                    <CardBody className="p-4">
                                        <div className="text-center mt-2">
                                            <h5 className="text-primary">Forgot Password</h5>
                                            <p className="text-muted">Please enter your email to receive a password reset link.</p>
                                        </div>
                                        <div className="p-2 mt-4">
                                            <Form
                                                onSubmit={(e) => {
                                                    e.preventDefault();
                                                    validation.handleSubmit();
                                                    return false;
                                                }}
                                                className="needs-validation"
                                                action="#"
                                            >
                                                {registrationError && registrationError ? (
                                                    <Alert color="danger">
                                                        <div>{registrationError}</div>
                                                    </Alert>
                                                ) : null}

                                                <div className="mb-3">
                                                    <Label htmlFor="email" className="form-label">
                                                        Email <span className="text-danger">*</span>
                                                    </Label>
                                                    <Input
                                                        id="email"
                                                        name="email"
                                                        className="form-control"
                                                        placeholder="Enter email address"
                                                        type="email"
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.email || ""}
                                                        invalid={validation.touched.email && validation.errors.email}
                                                    />
                                                    {validation.touched.email && validation.errors.email ? (
                                                        <FormFeedback type="invalid">
                                                            <div>{validation.errors.email}</div>
                                                        </FormFeedback>
                                                    ) : null}
                                                </div>

                                                <div className="mt-4">
                                                    <button
                                                        className="btn btn-success w-100"
                                                        type="submit"
                                                        disabled={loading}
                                                    >
                                                        {loading ? (
                                                            <>
                                                                <span
                                                                    className="spinner-border spinner-border-sm me-2"
                                                                    role="status"
                                                                    aria-hidden="true"
                                                                ></span>
                                                                Sending...
                                                            </>
                                                        ) : (
                                                            "Send"
                                                        )}
                                                    </button>
                                                </div>

                                                <div className="mt-4 text-center">
                                                    <p className="mb-0">
                                                        Remembered your password?{" "}
                                                        <Link
                                                            to="/login"
                                                            className="fw-semibold text-primary text-decoration-underline"
                                                        >
                                                            Sign In
                                                        </Link>
                                                    </p>
                                                </div>
                                            </Form>
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </ParticlesAuth>
            <ToastContainer />
        </React.Fragment>
    );
};

export default ForgetPasswordPage;